<template>
	<div class="team-detail">
		<div class="sideNav-box">
			<UiButton class="btn-back" @click="goBack">
				<i></i>
				<div class="label-box">
					<span class="label-shadow">返回</span>
					<span class="label-text">返回</span>
				</div>
			</UiButton>

			<div class="navList-box">
				<ul class="navList">
					<!-- 局数标签 -->
					<li
						v-for="(item, key) in sideNav"
						:key="key"
						:class="{ active: mark === item.id }"
						@click="switchMark(item)"
					>
						<div class="bg-active"></div>
						<div class="label-box">
							<span class="label-shadow">{{ item.name }}</span>
							<span class="label-text">{{ item.name }}</span>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="detail-container">
			<RouterView v-slot="{ Component }">
				<component :is="Component" :subTeam="subTeam" />
			</RouterView>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore } from '@/store'
import * as api from '@/service/index';
import UiButton from "@/components/ui-button";

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()

const sideNav = ref([
	{
		id: 'clan',
		name: '战队详情',
		child: 'DetailClan'
	},
	{
		id: 'members',
		name: '队员详情',
		child: 'DetailMembers'
	},
	{
		id: 'fan',
		name: '粉丝排行',
		child: 'DetailFanRanking'
	}
])
const mark = ref('clan')
const subTeam = ref({})
const subSeasonID = ref('')

const token = computed(() => appStore.token)
const seasonInfo = computed(() => appStore.seasonInfo)

watch(
	seasonInfo,
	(newVal) => {
		if (newVal && newVal.id) {
			subSeasonID.value = newVal.id
			// 获取战队信息
			getTeamsInfo()
		}
	},
	{
		immediate: true,
		deep: true
	}
)

onMounted(() => {
	initMark()

	// 触发导航栏的 二级导航
	appStore.navStatus = { level: 2, name: '战队' }
})

onUnmounted(() => {
	// 触发导航栏的 一级导航
	appStore.navStatus = { level: 1, name: '' }
})

// ...mapActions(useAppStore, ["reqTeamsList"]),
function initMark() {
	let routerName = route.name
	// console.log('routerName', routerName)
	switch (routerName) {
		case 'DetailClan':
			mark.value = 'clan'
			break
		case 'DetailMembers':
			mark.value = 'members'
			break
		case 'DetailFanRanking':
			mark.value = 'fan'
			break
		default:
			mark.value = 'clan'
			break
	}
}

function switchMark(item) {
	// console.log('item', item)
	if (mark.value !== item.id) {
		mark.value = item.id
		router.replace({
			name: item.child,
			params: { subTeam: subTeam.value }
		})
	}
}

async function getTeamsInfo() {
	if(!token.value) return;
	let data = {
		token: token.value,
		seasonId: subSeasonID.value,
		teamCode: route.params.id
	}
	let response = await api.reqTeamInfo(data)
	if (response.status === 200) {
		subTeam.value = response.data
	}
}

function goBack() {
	router.push({
		name: 'Ranking',
		params: {
			tab: 'team'
		},
		query: route.query
	})
}
</script>

<style lang="scss" scoped>
.team-detail {
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	background-image: $bg_container_inner;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	overflow: hidden;
	@include r(padding, 34, 28, 26, 36);

	.sideNav-box {
		@include r(margin-right, 12);

		.btn-back {
			position: relative;
			@include r(width, 187);
			@include r(height, 64);
			display: flex;
			align-items: center;
			justify-content: center;
			@include r(font-size, 26);
			background: url(https://website.xdcdn.net/poster/58881/26match/common/QSQFb485.png) center/contain no-repeat;
			@include r(margin-bottom, 12);

			i {
				position: relative;
				@include r(width, 22);
				@include r(height, 24);
				background: url(https://website.xdcdn.net/poster/58881/26match/icon/QSRWQgqe.png) center/contain no-repeat;
				@include r(margin-right, 20);
			}
			.label-box {
				line-height: 1;
			}
		}

		.navList-box {
			@include r(width, 155);
			@include r(height, 218);
			position: relative;
			flex-shrink: 0;
			flex-grow: 0;
			box-sizing: border-box;
			@include r(margin-left, 12);

			// 背景拆到伪元素, 相对内容整体下移不影响 li 布局
			&::before {
				content: '';
				position: absolute;
				@include r(top, 8);
				width: 100%;
				height: 100%;
				background: url(https://website.xdcdn.net/poster/58881/26match/common/QSSdZhau.png) center/contain no-repeat;
				// figma 标注 #C5C6CA multiply, css 阴影不支持混合模式, 换算等效半透明黑
				@include r_shadow(0, 2, 4, rgba(#000, 0.25));
			}

			.navList {
				width: 100%;
				height: 100%;
				@include r(font-size, 26);
				z-index: 1;

				li {
					position: relative;
					width: 100%;
					@include r(height, 73);
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						@include r(width, 116);
						@include r(height, 2);
						background-color: #6A1110;
					}

					.bg-active {
						position: absolute;
						@include r(width, 187);
						@include r(left, -12);
						height: 100%;
						box-sizing: border-box;
						background: url(https://website.xdcdn.net/poster/58881/26match/common/QSSdZg93.png) center/contain no-repeat;
						opacity: 0;
						@include r_shadow(0, 4, 4, rgba(#000, 0.2));
						transition: opacity ease-in-out 100ms;
					}

					.label-box {
						.label-shadow {
							color: #6A1110;
						}
					}

					&:last-child {
						&::after {
							display: none;
						}
					}

					&.active {
						&::after {
							display: none;
						}

						.bg-active {
							opacity: 1;
						}

						.label-box {
							@include r(margin-bottom, 6);
							.label-shadow {
								color: rgba(#FFF, 0.7);
							}
							.label-text {
								color: #513718;
							}
						}
					}
				}
			}
		}
	}

	.detail-container {
		position: relative;
		flex: 1;
		height: 100%;
	}
}
</style>
